module.exports = __webpack_public_path__ + "static/media/ease.b8f2f6aa.svg";